<!--Buttons-->
<div class="ButtonDiv">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onRefresh()">Refresh</button>
	<button [disabled]="IsLoading() == true" class="btn btn-primary SmallMarginLeft" (click)="onAdd()">Add Blocked Visitor</button>
	<button [disabled]="IsLoading() == true" class="btn btn-primary SmallMarginLeft" (click)="onEdit()">Edit Visitor</button>

	<button [disabled]="IsLoading() == true" class="btn btn-primary SmallMarginLeft" (click)="onBlockExceptions()">Edit Exceptions</button>

	<button [disabled]="IsLoading() == true" class="btn btn-primary SmallMarginLeft" (click)="onImport()">Import Block List</button>
	<button [disabled]="IsLoading() == true" class="btn btn-primary SmallMarginLeft" (click)="onExport()">Export Block List</button>
	<button [disabled]="IsLoading() == true" class="btn btn-primary SmallMarginLeft" (click)="onPrint()">Print</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>

<!--Table-->
<div>
	<p-table
		#mydt
		[value]="lstPerson"
		[loading]="IsLoading() == true"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedPerson"
		dataKey="PersonID"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th class="ImageCol"></th>

				<!--INSERT CUSTOM FILTERS HERE-->

				<!--FirstName-->
				<th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--IDIssuer-->
				<th>
					<p-columnFilter type="text" field="IDIssuer" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LicenseNbr-->
				<th>
					<p-columnFilter type="text" field="LicenseNbr" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Notes-->
				<th>
					<p-columnFilter type="text" field="Notes" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StatusDesc-->
				<th>
					<p-columnFilter field="StatusDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterStatusDesc
								[ngModel]="value"
								[options]="lstStatusDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ExceptionCount-->
				<th>
					<!-- <p-columnFilter type="text" field="ExceptionCount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th class="ImageCol"></th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="IDIssuer">State<p-sortIcon field="IDIssuer"></p-sortIcon></th>
				<th pSortableColumn="LicenseNbr">License Number<p-sortIcon field="LicenseNbr"></p-sortIcon></th>
				<th pSortableColumn="Notes">Notes<p-sortIcon field="Notes"></p-sortIcon></th>
				<th pSortableColumn="StatusDesc">Status<p-sortIcon field="StatusDesc"></p-sortIcon></th>
				<th pSortableColumn="ExceptionCount">Exceptions (By Facility)<p-sortIcon field="ExceptionCount"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Person>
			<tr *ngIf="Person.IsOffender == 0" [pSelectableRow]="Person" (dblclick)="onRowDblClick(Person)">
				<td class="ImageCol">
					<img class="VisitorImage" [src]="GetPhotoData(Person.PersonID)" />
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Person[col.field] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Person.StatusDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Person.IsOffender == true ? "N/A" : Person.ExceptionCount }}
				</td>
			</tr>

			<tr
				*ngIf="Person.IsOffender == 1"
				[pSelectableRow]="Person"
				(dblclick)="onRowDblClick(Person)"
				[ngClass]="{
					HighlightRow: SelectedPerson == undefined || Person.PersonID != SelectedPerson.PersonID,
					HighlightRowSelected: SelectedPerson != undefined && Person.PersonID == SelectedPerson.PersonID
				}"
			>
				<td class="ImageCol">
					<img class="VisitorImage" [src]="GetPhotoData(Person.PersonID)" />
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Person[col.field] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word; color: Red">
					{{ Person.StatusDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Person.IsOffender == true ? "N/A" : Person.ExceptionCount }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
